var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import AlertModal from "../Modal/AlertModal";
import AlertText from "../Modal/AlertText";
import { generateCsv, triggerCsvDownload } from "./CsvGenerator";
var CsvDownloaderModal = function (_a) {
    var show = _a.show, setShow = _a.setShow, columns = _a.columns, data = _a.data, fileName = _a.fileName, title = _a.title, continueText = _a.continueText, cancelText = _a.cancelText, bodyText = _a.bodyText;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        if (!loading) {
            return;
        }
        var csvContents = generateCsv(columns, data);
        triggerCsvDownload(fileName, csvContents, function () {
            setShow(false);
            setLoading(false);
        });
    }, [loading]);
    return (_jsx(AlertModal, __assign({ type: "info", loading: loading, show: show, continueText: continueText, cancelText: cancelText, title: title, onClose: function () { return setShow(false); }, onContinue: function () { return setLoading(true); } }, { children: _jsx(AlertText, { children: bodyText }) })));
};
export default CsvDownloaderModal;
